import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from 'react'
import CustomStore from 'devextreme/data/custom_store';
import SelectBox, { SelectBoxTypes } from 'devextreme-react/select-box';
import React from 'react';
import { t } from 'i18next';
import axios from 'axios';


interface LookupComboParams
{        
    title:string;
    name:string;
    api_url:string; 
    onvaluechange:(x:any)=>Promise<any>;     
}

const LookupCombo =forwardRef((params:LookupComboParams, ref) =>{

        const selectBox = useRef<any>(null);
        const [datasource,setdatasource] = useState<CustomStore>();
       
        const load= async function (p:any){
            return axios.get(params.api_url, {params: p})
            .then((response) => {return response.data;});
        };

        const onValueChanged = useCallback((e: SelectBoxTypes.ValueChangedEvent) => {
            params.onvaluechange(e.value)     
        }, []);
   

        useImperativeHandle(ref, () => {
            return {
            async refresh(p:any) { setdatasource(await load(p));},
            async clear(p:any) { setdatasource(undefined);selectBox.current.instance.clear();}
            };
        }, []);


    return (
    <>
        <label className="col-lg-1 col-form-label fw-bold fs-6">{params.title}</label>
        <div className="col-lg-2">
            <div className="row">
                <div className="fv-row">
                    <SelectBox
                        ref={selectBox}
                        name={params.name}                               
                        dataSource={datasource}
                        valueExpr="code"
                        displayExpr="name"
                        searchEnabled={true}
                        onValueChanged={onValueChanged}
                        showClearButton={true} />
                </div>
            </div>
        </div>
    </>
)})
    ;
  
  export default LookupCombo;